module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/regenerator/index.js
// module id = 334
// module chunks = 2